import React from 'react';

type Props = {
  width?: number;
  height?: number;
  color?: string;
  disabled?: boolean;
};

const IconResubmit: React.FC<Props> = ({
  width = 20,
  height = 20,
  color = '#FFFFFF',
  disabled = false,
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.4574 8.7207C14.0987 12.0154 11.3227 14.5 8 14.5C5.73533 14.5 3.66933 13.3194 2.5 11.4574V13.3333C2.5 13.6093 2.276 13.8333 2 13.8333C1.724 13.8333 1.5 13.6093 1.5 13.3333V10C1.5 9.724 1.724 9.5 2 9.5H5.33333C5.60933 9.5 5.83333 9.724 5.83333 10C5.83333 10.276 5.60933 10.5 5.33333 10.5H3.11328C4.03995 12.3173 5.918 13.5 8 13.5C10.8113 13.5 13.1594 11.3986 13.4634 8.61263C13.4927 8.3373 13.742 8.1406 14.014 8.16927C14.2893 8.19927 14.4867 8.44604 14.4574 8.7207ZM14 2.16667C13.724 2.16667 13.5 2.39067 13.5 2.66667V4.54264C12.3307 2.68064 10.2647 1.5 8 1.5C4.678 1.5 1.90198 3.98463 1.54264 7.2793C1.51264 7.55396 1.71068 7.80073 1.98535 7.83073C2.00335 7.83273 2.02204 7.83333 2.04004 7.83333C2.29204 7.83333 2.50864 7.64337 2.53597 7.38737C2.83997 4.60137 5.18868 2.5 7.99935 2.5C10.082 2.5 11.9594 3.68267 12.8861 5.5H10.6667C10.3907 5.5 10.1667 5.724 10.1667 6C10.1667 6.276 10.3907 6.5 10.6667 6.5H14C14.276 6.5 14.5 6.276 14.5 6V2.66667C14.5 2.39067 14.276 2.16667 14 2.16667Z"
      fill={disabled ? 'rgba(92, 101, 110, 1)' : color}
    />
  </svg>
);

export default IconResubmit;
